import { TravelineRegionsResponseDto } from '@/api/generated/fetch-client';

import { Region } from './region';

export class RegionList {
  constructor(readonly regions: Region[]) {}

  public static fromDto(dto: TravelineRegionsResponseDto): RegionList {
    return new RegionList(
      dto.regions.map((region) => new Region(region.id, region.name, region.countryCode)),
    );
  }
}
